<template>
  <div class="login">
    <div class="login__wrapper">
      <div
        class="login__image"
        :style="{
          'background-image': 'url(' + background + ')',
        }"
      >
        <div class="login__logo">
          <img class="login__logo-symbol" :src="symbol" />
          <img class="login__logo-type" :src="logo" />
        </div>
      </div>
      <div class="login__form-wrapper">
        <div class="login__form">
          <ResetPasswordForm />
        </div>
      </div>
    </div>

    <v-img class="login__background-cities" :src="background" />
  </div>
</template>

<script>
import logo from '@/assets/images/logo-hauseful-type-dark.svg'
import symbol from '@/assets/images/logo-hauseful-symbol-dark.svg'
import background from '@/assets/images/bg-login-cities.jpg'

import ResetPasswordForm from './login/ResetPasswordForm.vue'

export default {
  name: 'RecoverPassword',

  components: {
    ResetPasswordForm,
  },

  data: () => ({
    background,
    symbol,
    logo,
  }),

  mounted() {
    localStorage.clear()
  },
}
</script>
